import { SELECT_INFO_MODAL  } from '../actions';

export default (infoModalDetails = null, action) => {
    switch(action.type) {
        case SELECT_INFO_MODAL:
            return action.info;
        default:
            return infoModalDetails;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/infoModalDetailReducer.js